const FilterIconMobile = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'>
      <path
        d='M4.5 8H12.5M2.5 4H14.5M6.5 12H10.5'
        stroke='#515151'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const ActiveFilterIconMobile = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M4 8H12M2 4H14M6 12H10'
        stroke='#2378E5'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M18.3636 7.05025C18.7541 6.65972 18.7541 6.02656 18.3636 5.63603C17.9731 5.24551 17.3399 5.24551 16.9494 5.63603L11.9996 10.5858L7.04988 5.63603C6.65936 5.24551 6.02619 5.24551 5.63567 5.63603C5.24514 6.02656 5.24514 6.65972 5.63567 7.05025L10.5854 12L5.63567 16.9497C5.24514 17.3403 5.24514 17.9734 5.63567 18.364C6.02619 18.7545 6.65936 18.7545 7.04988 18.364L11.9996 13.4142L16.9494 18.364C17.3399 18.7545 17.9731 18.7545 18.3636 18.364C18.7541 17.9734 18.7541 17.3403 18.3636 16.9497L13.4138 12L18.3636 7.05025Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

const ClearAllIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M9 3.75C10.45 3.75 11.7614 4.33681 12.7123 5.2877C12.9738 5.54915 13.4013 6.01325 13.773 6.42312C13.9568 6.62572 14.1235 6.81131 14.2443 6.94627C14.3047 7.01373 14.3535 7.06847 14.3872 7.10628L14.4392 7.16466C14.7142 7.47439 14.6903 7.02503 15 6.75C15.3097 6.47496 15.8356 6.47809 15.5605 6.16837L15.5071 6.10831C15.4727 6.06977 15.4231 6.0142 15.3619 5.94584C15.2396 5.80917 15.0706 5.62105 14.8841 5.41541C14.5153 5.0088 14.0642 4.51825 13.773 4.22704C12.5523 3.00634 10.8638 2.25 9 2.25C5.27209 2.25 2.25 5.27209 2.25 9C2.25 12.7279 5.27209 15.75 9 15.75C10.8638 15.75 12.5523 14.9937 13.773 13.773L14.3033 13.2426L13.2426 12.182L12.7123 12.7123C11.7614 13.6632 10.45 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9C3.75 6.10051 6.10051 3.75 9 3.75Z'
        fill='#111212'
      />
      <path
        d='M15 2.91669C15.4142 2.91669 15.75 3.25247 15.75 3.66669V6.66669C15.75 7.0809 15.4142 7.41669 15 7.41669H12C11.5858 7.41669 11.25 7.0809 11.25 6.66669C11.25 6.25247 11.5858 5.91669 12 5.91669H14.25V3.66669C14.25 3.25247 14.5858 2.91669 15 2.91669Z'
        fill='#111212'
      />
    </svg>
  );
};

const MoreIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='14' viewBox='0 0 15 14' fill='none'>
      <path
        d='M3.70801 7H10.708M1.95801 3.5H12.458M5.45801 10.5H8.95801'
        stroke='#111212'
        strokeWidth='1.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export { FilterIconMobile, CloseIcon, ActiveFilterIconMobile, ClearAllIcon, MoreIcon };
